import type { CorrectionResponse } from "@api/types";
import { usePrincipalKey } from "@auth/sessionStore";
import { correctionsClient } from "@corrections/correctionsClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { questionKeys } from "../questions/questionsQueries";

export const useSubmitCorrection = () =>
  useMutation({
    mutationFn: correctionsClient.submit,
    meta: { action: "send your correction" },
  });

export const useCorrectionResult = (
  messageUuid: string,
  initial: CorrectionResponse,
) => {
  const principal = usePrincipalKey();
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ["corrections", principal, messageUuid],
    queryFn: () => correctionsClient.poll(messageUuid),
    initialData: initial,
    refetchInterval: (q) => (q.state.data?.status === "pending" ? 2000 : false),
  });

  const settledWithQuestions =
    query.data.status !== "pending" && query.data.questions.length > 0;
  useEffect(() => {
    if (settledWithQuestions)
      void queryClient.invalidateQueries({
        queryKey: questionKeys.inbox(principal),
      });
  }, [settledWithQuestions, principal, queryClient]);

  return query;
};
